import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

const SELECTORS = {
  bar: '.js-sticky-filters-bar',
  btn: '.js-sticky-filters-btn',
  panel: '.js-sticky-filters-panel',
  form: '.js-sticky-filters-form',
  sticky: '.js-sticky-filters-sticky',
  filter: '.js-sticky-filters-filter'
}

export default window.customElements.define(
  'sticky-filters',
  class extends CustomElement {
    constructor() {
      super()

      this.onImmersiveView = this.onImmersiveView.bind(this)

      this.events = {
        click: 'stopPropagation',
        mouseenter: 'onMouseenter',
        mouseleave: 'onMouseleave',
        [`mouseenter ${SELECTORS.btn}`]: 'onMouseenterBtn',
        [`submit ${SELECTORS.form}`]: 'onSubmit',
        [`click ${SELECTORS.filter}`]: 'onClickFilter'
      }
    }

    connectedCallback() {
      super.connectedCallback()

      this.$bar = this.querySelector(SELECTORS.bar)
      this.$btns = this.querySelectorAll(SELECTORS.btn)
      this.$panels = this.querySelectorAll(SELECTORS.panel)
      this.$form = this.querySelector(SELECTORS.form)
      this.$sticky = this.querySelector(SELECTORS.sticky)

      const observer = new IntersectionObserver(
        ([e]) => {
          this.toggle(e.intersectionRatio >= 0.5)
        },
        { threshold: [0.5, 1] }
      )

      observer.observe(this.$sticky.parentElement)

      Emitter.on('immersive-view', this.onImmersiveView)
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    stopPropagation(event) {
      if (this.focus) event.stopPropagation()
    }

    onImmersiveView(isImmersive) {
      this.toggle(!isImmersive)
    }

    onClickFilter() {
      this.hide()
    }

    onMouseenterBtn(event) {
      event.preventDefault()

      this.closeTimeoutId && clearTimeout(this.closeTimeoutId)

      const { nextElementSibling } = event.target

      // const alreadyOpen = event.target.classList.contains('is-active')

      this.hide()

      if (this.open || !nextElementSibling.matches(SELECTORS.panel)) return

      event.target.classList.add('is-active')
      this.show(nextElementSibling)
    }

    onSubmit() {
      console.log('submit')
    }

    toggle(show) {
      this.classList.toggle('is-out', !show)
    }

    show(panel) {
      this.open = true
      this.showTimeoutId && clearTimeout(this.showTimeoutId)

      const { clientHeight, clientWidth } = panel
      const { clientWidth: minWidth } = this.$bar
      this.style.setProperty(
        '--clip',
        `inset(${clientHeight}px 0% 0% ${
          panel.dataset.grow ? 0.5 * minWidth : 0
        }px round .6rem)`
      )
      this.style.setProperty('--target-height', `${28 + clientHeight}px`)

      const targetWidth = minWidth * 1.5
      if (panel.dataset.grow) {
        this.style.setProperty('--target-width', `${targetWidth}px`)
        this.style.setProperty(
          '--translate-x',
          `${clientWidth - targetWidth}px`
        )
      }

      this.showTimeoutId = setTimeout(() => {
        panel.classList.add('is-active')
        this.classList.add('is-active')
        const input = panel.querySelector('input[type=text]')
        if (input) {
          input.focus()
          this.focus = true
        } else {
          this.focus = false
        }
      }, 100)

      document.addEventListener('click', this.hide.bind(this), { once: true })
    }

    hide(event) {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }
      if (!this.open) return

      this.focus = false
      ;[...this.$btns, ...this.$panels, this].forEach((p) =>
        p.classList.remove('is-active')
      )

      this.style.setProperty('--target-height', '')
      this.style.setProperty('--target-width', '')
      this.style.setProperty('--clip', '')
      this.style.setProperty('--translate-x', '')

      this.open = false
    }

    onMouseenter() {
      this.closeTimeoutId && clearTimeout(this.closeTimeoutId)
    }

    onMouseleave() {
      if (this.focus) return
      this.closeTimeoutId = setTimeout(this.hide.bind(this), 300)
    }
  }
)
